import {
  banAccount,
  completeCardVerification,
  createAppAttestChallenge,
  createCardVerification,
  createSignInCheck,
  getAccount,
  unbanAccount,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AccountBan,
  AccountRiskParams,
  AccountRiskResponse,
  AccountStanding,
  AccountTier,
  AppAttestChallengeResponse,
  BanAccountBody,
  CARD_VERIFICATION_RETURN_PARAM,
  CardVerificationId,
  CardVerificationOutcome,
  CardVerificationResponse,
  CreateCardVerificationBody,
  CreateSignInCheckBody,
  RiskFactKind,
  RiskFactRecord,
  SIGN_IN_CHECK_RECAPTCHA_ACTION,
  StandingSignal,
} from "./schemas";

export const contract = {
  signInChecks: { create: createSignInCheck },
  appAttestChallenges: { create: createAppAttestChallenge },
  cardVerifications: { create: createCardVerification, complete: completeCardVerification },
  accounts: { get: getAccount, ban: banAccount, unban: unbanAccount },
} as const;
